import { useEffect } from 'react';

const CloseWindow: React.FC = () => {
  useEffect(() => {
    const bc = new BroadcastChannel('sso');
    bc.postMessage({ action: 'closeWindow' });
    window.close();
  }, []);
  return <div>You're about to be redirected</div>;
};

export default CloseWindow;
